var APP = {} // eslint-disable-line

import { include } from './bundler'
import { logger } from './logger'
import { copy } from './copy'
import { collection } from './collection'
import { locale } from './locale'
import { numeric } from './numeric'
import { date } from './date'
import { json } from './json'
import { constants } from './constants'
import './polyfills'
import { cookie } from './cookie'

Object.defineProperty(utils, 'app', {
  get: () => APP,
  set: (val) => { APP = val }
})

const cssProps = {
  init: () => setTimeout(global.cssVarPoly.init, 450),
  refresh: () => setTimeout(() => {
    global.cssVarPoly.findCSS()
    global.cssVarPoly.updateCSS()
  }, 450)
}

export { include, logger, copy, cssProps, collection, locale, numeric, date, json, constants, cookie }

global.setCookie = function (name, value, exdays, path) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + exdays)
  var cValue = escape(value) + ((exdays === null) ? '' : '; expires=' + exdate.toUTCString())
  path = '/'
  cValue += '; path=/'
  if (typeof path !== 'undefined') {
    cValue += '; path=' + path
  }
  document.cookie = name + '=' + cValue
}

global.getCookie = function (name) {
  var i, x, y
  var ARRcookies = document.cookie.split(';')
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='))
    y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1)
    x = x.replace(/^\s+|\s+$/g, '')
    if (x === name) {
      return unescape(y)
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/index.js